import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configure-store';
import App from './containers/app';
import './styles/index.css';

const store = configureStore({});

ReactDOM.render(
  <Provider store={ store }>
    <App />
  </Provider>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/